import React from 'react';
import { connect } from 'react-redux';


function mapStateToProps(state) {
  return {
    sessionState: state.session,
  };
}


export default function withSessionState() {
  return (Component) => {
    const Wrapped = (props) => <Component {...props} />;
    return connect(mapStateToProps, null)(Wrapped);
  };
}



// WEBPACK FOOTER //
// ./src/components/hocs/withSessionState.js